// extracted by mini-css-extract-plugin
module.exports = {"burgerNav":"Navbar_burgerNav__2kVe7"};